import { format } from 'date-fns/format';
import { parse } from 'date-fns/parse';
import zod from 'zod';

import {
  dateValueSchema,
  normalizeDate,
  type NormalizedDate,
} from '../../core/logical/date-value.js';
import { t } from '../../core/logical/type-presets.js';
import { propertyType } from '../../core/property/property-config.js';

// re-exported from their original home so `@blocksuite/data-view/property-presets`
// keeps working for consumers outside this package
export { normalizeDate, type NormalizedDate };

export const datePropertyType = propertyType('date');
export const datePropertyModelConfig = datePropertyType.modelConfig({
  name: 'Date',
  propertyData: {
    schema: zod.object({}),
    default: () => ({}),
  },
  jsonValue: {
    schema: dateValueSchema,
    isEmpty: () => false,
    type: () => t.date.instance(),
  },
  rawValue: {
    schema: dateValueSchema,
    default: () => null,
    toString: ({ value }) => {
      const norm = normalizeDate(value);
      if (!norm) return '';
      const fmt = norm.hasTime ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd';
      const startStr = format(norm.start, fmt);
      if (norm.end) {
        return `${startStr} - ${format(norm.end, fmt)}`;
      }
      return startStr;
    },
    fromString: ({ value }) => {
      const date = parse(value, 'yyyy-MM-dd', new Date());
      return { value: +date };
    },
    toJson: ({ value }) => normalizeDate(value)?.start ?? null,
    fromJson: ({ value }) => value,
  },
});
